import { useState, useEffect } from 'react'
import { notification } from 'antd'
import { retrySendMap } from '@/api/robots.api'

export function useRobotMapRetry(
  robotId: string,
  refetchDetail: () => Promise<any>,
  refetchPositions: () => void,
) {
  const [isRetrying, setIsRetrying] = useState(false)
  const [retrySeconds, setRetrySeconds] = useState(60)

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (isRetrying && retrySeconds > 0) {
      timer = setInterval(() => setRetrySeconds((prev) => prev - 1), 1000)
    }
    return () => clearInterval(timer)
  }, [isRetrying, retrySeconds])

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms))

  const handleRetrySendMap = async () => {
    if (!robotId) return
    setIsRetrying(true)
    notification.info({
      description: 'Đang gửi lệnh yêu cầu robot gửi sơ đồ sàn mới...',
      duration: 5,
    })
    setRetrySeconds(60)

    try {
      const response = await retrySendMap(robotId, undefined)
      if (response.status !== 200)
        throw new Error('Yêu cầu quét bản đồ thất bại')

      let updatedRobot = null
      let attempts = 0
      while (attempts < 2) {
        await sleep(30000)
        const queryResult = await refetchDetail()
        updatedRobot = queryResult.data
        if (updatedRobot?.mapFileUrl) break
        attempts++
      }
      if (updatedRobot?.mapFileUrl) {
        refetchPositions()
        notification.success({
          title: 'Đã cập nhật xong sơ đồ sàn và vị trí mới.',
        })
      } else {
        notification.warning({
          description: 'Quá trình tạo bản đồ mất nhiều thời gian hơn dự kiến.',
        })
      }
    } catch {
      notification.error({
        title: 'Không thể xử lý yêu cầu hoặc làm mới dữ liệu sơ đồ sàn.',
      })
    } finally {
      setIsRetrying(false)
      setRetrySeconds(0)
    }
  }

  return { isRetrying, retrySeconds, handleRetrySendMap }
}
